const BASE_API = process.env.MIX_ENDLESS_API_URL

const state ={
	applications:[],
	quotes:[],
	favorites:[],
	documents:[],
	documentsTypes:[],
	catalogAssociatedCountries:[],
	countries:[],
	cities:[],
	languages:[],
	graduations:[],
	graduation:[],
	graduationsTypes:[],
	noteSystem:[],
	testTypes:[],
	tests:[],
	test:[],
	visas:[],
	comments:[],
	commentQuestions:null,
	uploadedFile:'',
	init:{},
	user:{},
	notification: {
		show: false,
		title: "",
		description: "",
		// accepted ['error', 'success', 'info', 'warning']
		type: "success",
	},
	avatar:'',
	activeProfileTab:'personal',
	previousVisas:[],
	visaType:[],
	blogFavorites:[],
	appoinmentTime:[],
	payments:[],
	loadingCountries: false
}
const getters = {
	applicationsGetter:({applications}) => applications,
	quotesGetter:({quotes}) => quotes,
	favoritesGetter:({favorites}) => favorites,
	documentsGetter:({documents}) => documents,
	documentsTypesGetter:({documentsTypes}) => documentsTypes,
	catalogAssociatedCountriesGetter:({catalogAssociatedCountries}) => catalogAssociatedCountries,
	countriesGetter:({countries}) => countries,
	loadingCountriesGetter:({loadingCountries}) => loadingCountries,
	citiesGetter:({cities}) => cities,
	languagesGetter:({languages}) => languages,
	graduationsGetter:({graduations}) => graduations,
	graduationGetter:({graduation}) => graduation,
	graduationsTypesGetter:({graduationsTypes}) => graduationsTypes,
	noteSystemGetter:({noteSystem}) => noteSystem,
	testTypesGetter:({testTypes}) => testTypes,
	testsGetter:({tests}) => tests,
	testGetter:({test}) => test,
	uploadedFileGetter:({uploadedFile}) => uploadedFile,
	visasGetter:({visas}) => visas,
	commentsGetter:({comments}) => comments,
	commentQuestionsGetter:({commentQuestions}) => commentQuestions,
	initGetter:({init}) => init,
	userGetter:({user}) => user,
	avatarGetter:({avatar}) => avatar,
	activeProfileTabGetter:({activeProfileTab}) => activeProfileTab,
	getNotification: (state) => {
		return state.notification;
	},
	visasPreviousGetter:({previousVisas}) => previousVisas,
	visasTypeGetter:({visaType}) => visaType,
	blogFavoriteGetter:({blogFavorites}) => blogFavorites,
	appointmentTimeGetter:({appoinmentTime})=>appoinmentTime,
	paymentsGetter:({payments})=>payments
}

const mutations = {
	setApplications : (state,payload)=> state.applications = payload,
	setQuotes : (state,payload)=> state.quotes = payload,
	setFavorites : (state,payload)=> state.favorites = payload,
	setDocuments : (state,payload)=> state.documents = payload,
	setDocumentsTypes : (state,payload)=> state.documentsTypes = payload,
	setCatalogAssociatedCountries: (state,payload)=> state.catalogAssociatedCountries = payload,
	setCountries : (state,payload)=> state.countries = payload,
	setCities : (state,payload)=> state.cities = payload,
	setLanguages : (state,payload)=> state.languages = payload,
	setGraduations : (state,payload)=> state.graduations = payload,
	setGraduation : (state,payload)=> state.graduation = payload,
	setGraduationsTypes : (state,payload)=> state.graduationsTypes = payload,
	setNoteSystem : (state,payload)=> state.noteSystem = payload,
	setTestTypes : (state,payload)=> state.testTypes = payload,
	setTests : (state,payload)=> state.tests = payload,
	setTest : (state,payload)=> state.test = payload,
	setVisas : (state,payload)=> state.visas = payload,
	setComments : (state,payload)=> state.comments = payload,
	setCommentQuestions : (state,payload)=> state.commentQuestions = payload,
	setUploadedFile : (state,payload)=> state.uploadedFile = payload,
	setNotification(state, notification) {
		state.notification = notification;
	},
	setInit : (state,payload)=> state.init = payload,
	setAvatar : (state,payload)=> state.avatar = payload,
	setUser : (state,payload)=> state.user = payload,
	setActiveProfileTab : (state,payload)=> state.activeProfileTab = payload,
	setPreviousVisas : (state,payload)=> state.previousVisas = payload,
	setVisaType: (state, payload) => state.visaType = payload.map(item => ({ id: item.id, name: `${item.place.name} / ${item.name}` })),
	setBlogFavorites: (state, payload) => state.blogFavorites = payload,
	setBlogDeleteFavorites:(state,payload) => state.blogFavorites = state.blogFavorites.filter(fav => fav.id !== payload),
	setAppointmentTime:(state,payload) => state.appoinmentTime = payload,
	setPaymentsInfo:(state,payload) => state.payments = payload,
	setLoadingCountries(state, payload) {state.loadingCountries = payload;}

}

const actions = {
	async getInit({commit}, payload){
		await this.$axios.get(`${BASE_API}/init`).then(res => {
			commit('setInit',res.data.result.auth)
		})
	},
	async getUser({commit, rootState}, payload){
		await this.$axios.get(`${BASE_API}/users/${rootState.global.init.id}`).then(res => {
			commit('setUser',res.data.result)
		})
	},
	async getQuotes({commit}, payload){
		await this.$axios.get(`${BASE_API}/quotes`).then(res => {
			commit('setQuotes',res.data.result.data)
		})
	},
	async getApplications({commit}, payload){
		await this.$axios.get(`${BASE_API}/applications`).then(res => {
			commit('setApplications',res.data.result)
		})
	},
	async getFavorites({commit}, payload){
		await this.$axios.get(`${BASE_API}/favorites`).then(res => {
			commit('setFavorites',res.data.result.data)
		})
	},
	async getDocuments({commit}, payload){
		await this.$axios.get(`${BASE_API}/files`).then(res => {
			commit('setDocuments',res.data.result.data)
		})
	},
	async postDocuments({commit}, payload){
		await this.$axios.post(`${BASE_API}/files`, payload).then(res => {

		})
	},
	async deleteDocuments({commit}, id){
		await this.$axios.delete(`${BASE_API}/files/${id}`).then(res => {
		})
	},
	async getDocumentsTypes({commit}, payload){
		await this.$axios.get(`${BASE_API}/file-types`).then(res => {
			commit('setDocumentsTypes',res.data.result.data)
		})
	},
	async getCatalogAssociatedCountries({commit}, payload){
		const params = {
			filters: 'has_catalog:true;is_country:true;page_limit:250;',
			...payload
		}
		await this.$axios.get(`${BASE_API}/places`, {params}).then(res => {
			commit('setCatalogAssociatedCountries',res.data.result.data)
		})
	},
	async getCountries({commit}, payload){
		commit('setLoadingCountries', true);
		const params = {
			filters: 'is_country:true;page_limit:250;is_except_school_type:true',
			...payload
		}
		await this.$axios.get(`${BASE_API}/places`, {params}).then(res => {
				commit('setCountries', res.data.result.data);
				commit('setLoadingCountries', false);
		})
	},
	async getCities({commit}, countryID){
		await this.$axios.get(`${BASE_API}/places/${countryID}/cities?filters=is_except_school_type:true`).then(res => {
			commit('setCities',res.data.result.data)
		})
	},
	async getLanguages({commit}){
		await this.$axios.get(`${BASE_API}/languages`).then(res => {
			commit('setLanguages',res.data.result.data)
		})
	},
	async getGraduations({commit}, payload){
		await this.$axios.get(`${BASE_API}/graduations`).then(res => {
			commit('setGraduations',res.data.result.data)
		})
	},
	async getGraduation({commit}, id){
		await this.$axios.get(`${BASE_API}/graduations/${id}`).then(res => {
			commit('setGraduation',res.data.result)
		})
	},
	async deleteGraduation({commit}, id){
		await this.$axios.delete(`${BASE_API}/graduations/${id}`).then(res => {
			commit('setGraduation',res.data.result)
		})
	},
	async getGraduationsTypes({commit}, payload){
		await this.$axios.get(`${BASE_API}/graduation-levels`).then(res => {
			commit('setGraduationsTypes',res.data.result.data)
		})
	},
	async getNoteSystem({commit}, payload){
		await this.$axios.get(`${BASE_API}/graduation-schemes`).then(res => {
			commit('setNoteSystem',res.data.result.data)
		})
	},
	async getTestTypes({commit}, payload){
		await this.$axios.get(`${BASE_API}/test-types`).then(res => {

			commit('setTestTypes',res.data.result.data)
		})
	},
	async getTests({commit}, payload){
		await this.$axios.get(`${BASE_API}/tests`).then(res => {
			commit('setTests',res.data.result.data)
		})
	},
	async getTest({commit}, id){
		await this.$axios.get(`${BASE_API}/tests/${id}`).then(res => {
			commit('setTest',res.data.result)
		})
	},
	async getVisas({commit}, payload){
		await this.$axios.get(`${BASE_API}/visa-progresses`).then(res => {
			commit('setVisas',res.data.result.data)
		})
	},
	async getComments({commit}, payload){
		await this.$axios.get(`${BASE_API}/comments`).then(res => {
			console.log('res',res)
			commit('setComments',res.data.result.data)
		})
	},
	async getCommentQuestions({commit}, campusId){
		await this.$axios.get(`${BASE_API}/comment-questions?campus_id=${campusId}`).then(res => {
			commit('setCommentQuestions',res.data.result)
		})
	},
	async updateVisasFields({commit}, payload){
		const visasData = state.visas[0]
		await this.$axios.put(`${BASE_API}/visa-progresses/${visasData.id}`,{fields: payload})
	},
	async updateVisasItems({commit}, items){
		var visasData =  state.visas[0]
		await this.$axios.put(`${BASE_API}/visa-progresses/${visasData.id}`,{
			items : items
		}).then(res => {
			const data = []
			data.push(res.data.result)
			// state.visas[state.visas.length-1] = res.data.result
			// visasData = res.data.result.items
			commit('setVisas',data)
		})
	},
	async addTests({commit}, form){
		return this.$axios.post(`${BASE_API}/tests`,form).then(response => {
			return response;
		}).catch(error => {
			return error.response
		})
	},
	async createComment({commit}, form){
		return this.$axios.post(`${BASE_API}/comments`,form).then(response => {
			return response;
		}).catch(error => {
			return error.response
		})
	},
	async editTestInfo({ dispatch, commit },form) {
		let id = form.id
		delete form['id']
		this.form = form
		return this.$axios.put(`${BASE_API}/tests/${id}`, form).then(response => {
			return response.data.result.data;
		}).catch(error => {
			return error.response
		})
	},
	async deleteTestInfo({ dispatch, commit },form) {
		let id = form.id
		delete form['id']
		this.form = form
		return this.$axios.delete(`${BASE_API}/tests/${id}`).then(response => {
			return response.data.result.data;
		}).catch(error => {
			return error.response
		})
	},
	async putPersonalInformation({ dispatch, commit, rootState },form){
		return await this.$axios.put(`${BASE_API}/users/${rootState.global.init.id}`, form).then(res => {
			state.user = res
			return res
		})
	},
	async uploadFile({ dispatch, commit }, file) {
		await this.$axios.post(`${BASE_API}/eduvisors/file-upload`, file).then(res => {
			commit('setUploadedFile',res)
			// commit('setUploadedFile',res.data.result.file)
			return res
		}).catch(error => {
			return error.response
		});
	},
	async setAvatar({ dispatch, commit }, payload) {
		commit('setAvatar',payload.avatar)
	},
	async editAvatar({ dispatch, commit, rootState }, payload) {

		return await this.$axios.put(`${BASE_API}/users/${rootState.global.init.id}`,{avatar: state.avatar}).then(response => {
			return response;
		}).catch(error => {
			return error
		});
	},
	async addEducationInfo({ dispatch, commit }, form) {
		return await this.$axios.post(`${BASE_API}/graduations`, form).then(response => {
			return response.data.result.data;
		}).catch(error => {
			return error.response
		})
	},
	async changePassword({ dispatch, commit }, form) {
		await this.$axios.put(`${BASE_API}/me/change-password`, form).then(res => {
		})
	},
	async changeTimezone({ dispatch, commit }, payload) {
		await this.$axios.put(`${BASE_API}/users/${payload.payload.userID}`,{timezone: payload.payload.timezone}).then(res => {
		})
	},
	async changeEmail({ dispatch, commit }, form) {
		await this.$axios.put(`${BASE_API}/me/change-email`, form).then(res => {
		})
	},
	async editEducationInfo({ dispatch, commit }, form) {
		let id = form.id
		delete form['id']
		this.form = form
		return this.$axios.put(`${BASE_API}/graduations/${id}`, form).then(response => {
			return response.data.result.data;
		}).catch(error => {
			return error.response
		})
	},
	async deleteAccount({ dispatch, commit }){
		await this.$axios.delete(`${BASE_API}/me/delete`).then(res => {
		})
	},

	showNotification(context, notification) {
		context.commit("setNotification", {...notification, show: true});
		setTimeout(function () {
			context.dispatch("hideNotification").then(r => {
				return r
			});
		}, 10000);
	},
	hideNotification(context) {
		context.commit("setNotification", {
			show: false,
			title: "",
			description: "",
			type: "success",
		});
	},
	async getPreviousVisas({commit}, payload){
		await this.$axios.get(`${BASE_API}/visas`).then(res => {
			commit('setPreviousVisas',res.data.result)
		})
	},
	async getVisaType({commit}, payload){
		await this.$axios.get(`${BASE_API}/visa-types`).then(res => {
			commit('setVisaType',res.data.result.data)
		})
	},
	async addVisas({commit}, form){
		return this.$axios.post(`${BASE_API}/visas`,form).then(response => {
			commit('setPreviousVisas',response.data.result)
		})
	},
	async deleteVisas({commit},id){
		await this.$axios.delete(`${BASE_API}/visas/${id}`).then(res => {
			commit('setPreviousVisas',res.data.result)
		})
	},
	async getBlogFavorite({commit}){
		await this.$axios.get(`/profile/favorite-blogs`).then(res => {
			commit('setBlogFavorites',res.data.result.data)
		})
	},
	async createBlogFavorites({commit}, payload){
		await this.$axios.post(`profile/add-to-favorite-blog`,payload).then(res => {
			commit('setBlogFavorites',res.data.result.data)
		})
	},
	async deleteBlogFavorites({commit}, payload){
		$('#loading').show();
		await this.$axios.post(`profile/remove-from-favorite-blog`,payload).then(res => {
			commit('setBlogDeleteFavorites',payload.blog_id)
			$('#loading').hide();
		})
	},
	async getAvailability({commit},payload){
		const params ={ date:payload.date }
		await this.$axios.get(`${BASE_API}/calendar/${payload.username}/availability`, {params:params}).then(res => {
			commit('setAppointmentTime',res.data.result)
		})
	},
	async addAvailability({ dispatch, commit }, from) {
		return await this.$axios.post(`${BASE_API}/calendar/${from.username}/create-appointment`, from).then(response => {
			return response.data.result.data;
		}).catch(error => {
			return error.response
		})
	},
	async getPayments({commit}){
		await this.$axios.get(`${BASE_API}/payments`).then(res => {
			commit('setPaymentsInfo',res.data.result.data)
		})
	},
}

export default {namespaced:true,state,getters,mutations,actions}
